import { Component, onMount } from "solid-js";
import { FsModalDialog } from "@cof/fs-modal-dialog-wc";
import {
  publishAdminEligibilityModalView,
  publishAdminEligibilityModalOkClick,
} from "@/services/analytics.service";

interface AdminEligibilityModalProps {
  onClose: (modalRef: FsModalDialog) => void;
}

export const AdminEligibilityModal: Component<AdminEligibilityModalProps> = (
  props,
) => {
  let modalRef: FsModalDialog | undefined;

  onMount(() => {
    publishAdminEligibilityModalView();
  });

  return (
    <fd-mfe-modal-dialog
      ref={modalRef}
      prop:open={true}
      data-testid="admin-eligibility-modal"
    >
      <h2 slot="modal-dialog-header" data-testid="admin-eligibility-heading">
        You don't have access
      </h2>
      <p slot="modal-dialog-body" data-testid="admin-eligibility-message">
        Contact an admin at your dealership to book a Featured Dealer campaign.
      </p>
      <fd-mfe-modal-dialog-footer slot="modal-dialog-footer">
        <fd-mfe-button
          onClick={() => {
            publishAdminEligibilityModalOkClick();
            if (modalRef) props.onClose(modalRef);
          }}
        >
          Back to marketing
        </fd-mfe-button>
      </fd-mfe-modal-dialog-footer>
    </fd-mfe-modal-dialog>
  );
};
